<div class="map-page">
  <div class="map-page__container">
    <h1 class="map-page__title">Información Corporativa</h1>
    <div class="informaciones-page">
  <div class="container">
    <header class="page-header">

    </header>

    <app-informaciones-grid></app-informaciones-grid>
  </div>
</div>
  </div>
</div> 

